import { AccountProductEnum, Mutation } from '@varo/graphql-schema-types';
import { useCallback, useEffect } from 'react';
import SetAccountNicknameR2 from 'services/graphql/mutations/SetAccountNicknameR2';
import { usePressableAnalytics } from 'shared/hooks/analytics/usePressableAnalytics';
import useCancellableMutation from 'shared/hooks/useCancellableMutation';
import { getUuid } from 'shared/utils/getUuid/getUuid';

const useUpdateNickname = (
  accountId: string,
  accountType: AccountProductEnum,
) => {
  const [{ data, fetching, error }, executeMutation] =
    useCancellableMutation<Mutation>(SetAccountNicknameR2);
  const pressEvent = usePressableAnalytics({
    analyticsId:
      accountType === AccountProductEnum.Savings
        ? 'savingsNickNameUpdate'
        : 'checkingNickNameUpdate',
  });

  const handleSavePress = useCallback(
    (newNickname: string) => {
      return executeMutation({
        idempotencyId: getUuid(),
        accountId,
        nickname: newNickname,
      });
    },
    [accountId, executeMutation],
  );

  useEffect(() => {
    if (data) {
      pressEvent();
    }
  }, [data, pressEvent]);

  return {
    data,
    loadingNickName: fetching,
    errorNickname: error,
    handleSavePress,
  };
};

export default useUpdateNickname;
